const CandidateEngagementBadges = {
  ActionNeeded: 'Action Needed',
  InterviewConfirmed: 'Fulfillment Complete',
  InterviewExpected: 'Interview Confirmed',
  New: 'New',
  WaitingOnClient: 'Waiting On Client',
} as const;

export const CandidateEngagementsConst = {
  Badges: CandidateEngagementBadges,
};
